import React, { FC } from 'react';
import cx from 'classnames';
import { ReactComponent as LightningGreenIcon } from 'new/components/icons/fi-rr-bolt.svg';
import { ReactComponent as InitializedIcon } from 'new/components/icons/fi-rr-opacity.svg';
import { ReactComponent as PausedIcon } from 'new/components/icons/fi-rr-pause.svg';
import { ReactComponent as SignalIcon } from 'new/components/icons/fi-rr-sign-out-alt.svg';
import Typography from 'new/elements/TypographySupport';
import styles from './ligtningStatus.module.scss';
import Constants from 'js/Constants';
import * as credentialStatus from 'js/constants/credentialStatus';
import { BarChart, Check } from '@mui/icons-material';
import CloseIcon from '@mui/icons-material/Close';

type Props = {
  status: string;
  className?: string;
  size?: 'normal' | 'small';
  id?: number | string;
};

const icons = {
  active: LightningGreenIcon,
  paused: PausedIcon,
  initialized: InitializedIcon,
  rateLimited: SignalIcon,
  valid: Check,
  invalid: CloseIcon,
};

const LightningStatus: FC<Props> = ({ status, className, id = '', size = 'normal' }) => {
  let statusName;
  let statusDisplayName;

  switch (status) {
    case Constants.SourceStatus.ACTIVE:
      statusName = 'active';
      statusDisplayName = 'Active';
      break;
    case Constants.SourceStatus.PAUSED:
      statusName = 'paused';
      statusDisplayName = 'Paused';
      break;
    case Constants.SourceStatus.RATE_LIMITED:
      statusName = 'rateLimited';
      statusDisplayName = 'Rate Limited';
      break;
    case credentialStatus.CREDENTIAL_VALID:
      statusName = 'valid';
      statusDisplayName = 'Valid';
      break;
    case credentialStatus.CREDENTIAL_INVALID:
      statusName = 'invalid';
      statusDisplayName = 'Invalid';
      break;
    default:
      statusName = 'initialized';
      statusDisplayName = 'Initialized';
  }

  const iconClassName = styles[statusName];
  const Icon = icons[statusName] || icons.initialized;

  return (
    <div
      className={cx(styles.status, className, styles['status_' + size])}
      data-testid={`lightning-status-${id}`}
    >
      <Icon className={cx(styles.icon, iconClassName)} />
      <Typography className={cx(styles.label, styles[statusName])}>{statusDisplayName}</Typography>
    </div>
  );
};

export default LightningStatus;
